import script from "./resourceSharing.vue?vue&type=script&setup=true&lang=js"
export * from "./resourceSharing.vue?vue&type=script&setup=true&lang=js"

import "./resourceSharing.vue?vue&type=style&index=0&id=76b688ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76b688ea"]])

export default __exports__